import { createApp } from 'vue'
import LanguageSwitcher from './components/LangSwitcher.vue'

const el = document.getElementById('lang-switcher')
if (el) {
    const locale = el.getAttribute('data-locale') || window.APP_LOCALE || 'en'
    const altUrl = el.getAttribute('data-alt-url') || null
    createApp(LanguageSwitcher, { locale, altUrl }).mount('#lang-switcher')
    createApp(LanguageSwitcher, { locale }).mount('#lang-switcher2')
    createApp(LanguageSwitcher, { locale }).mount('#lang-switcher3')
}